import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./components/App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// const f10180 = useRef();
// const f10420 = useRef();
// const f10580 = useRef();
// const f10740 = useRef();
// const f10900 = useRef();
// const f11100 = useRef();
// const f14010 = useRef();
// const f11540 = useRef();
// const f12060 = useRef();
// const f12100 = useRef();
// const f12420 = useRef();
// const f12580 = useRef();
// const f12700 = useRef();
// const f12940 = useRef();
// const f13140 = useRef();
// const f13780 = useRef();
// const f13820 = useRef();
// const f13900 = useRef();
// const f14260 = useRef();
// const f14460 = useRef();
// const f14500 = useRef();
// const f14540 = useRef();
// const f14860 = useRef();
// const f15380 = useRef();
// const f15540 = useRef();
// const f15940 = useRef();
// const f15980 = useRef();
// const f16020 = useRef();
// const f16300 = useRef();
// const f16580 = useRef();
// const f16620 = useRef();
// const f16700 = useRef();
// const f16740 = useRef();
// const f16860 = useRef();
// const f16980 = useRef();
// const f17140 = useRef();
// const f17460 = useRef();
// const f17820 = useRef();
// const f17860 = useRef();
// const f17900 = useRef();
// const f18140 = useRef();
// const f18580 = useRef();
// const f18880 = useRef();
// const f19060 = useRef();
// const f19100 = useRef();
// const f19340 = useRef();
// const f19380 = useRef();
// const f19460 = useRef();
// const f19500 = useRef();
// const f19660 = useRef();
// const f19740 = useRef();
// const f19780 = useRef();
// const f19820 = useRef();
// const f20100 = useRef();
// const f20500 = useRef();
// const f21300 = useRef();
// const f21340 = useRef();
// const f21500 = useRef();
// const f21660 = useRef();
// const f22020 = useRef();
// const f22140 = useRef();
// const f22180 = useRef();
// const f22220 = useRef();
// const f22500 = useRef();
// const f22540 = useRef();
// const f22660 = useRef();
// const f23060 = useRef();
// const f23420 = useRef();

// const refs = [
//   f10180,
//   f10420,
//   f10580,
//   f10740,
//   f10900,
//   f11100,
//   f14010,
//   f11540,
//   f12060,
//   f12100,
//   f12420,
//   f12580,
//   f12700,
//   f12940,
//   f13140,
//   f13780,
//   f13820,
//   f13900,
//   f14260,
//   f14460,
//   f14500,
//   f14540,
//   f14860,
//   f15380,
//   f15540,
//   f15940,
//   f15980,
//   f16020,
//   f16300,
//   f16580,
//   f16620,
//   f16700,
//   f16740,
//   f16860,
//   f16980,
//   f17140,
//   f17460,
//   f17820,
//   f17860,
//   f17900,
//   f18140,
//   f18580,
//   f18880,
//   f19060,
//   f19100,
//   f19340,
//   f19380,
//   f19460,
//   f19500,
//   f19660,
//   f19740,
//   f19780,
//   f19820,
//   f20100,
//   f20500,
//   f21300,
//   f21340,
//   f21500,
//   f21660,
//   f22020,
//   f22140,
//   f22180,
//   f22220,
//   f22500,
//   f22540,
//   f22660,
//   f23060,
//   f23420,
// ];
